import React from "react";

interface HighlightedHeadingProps {
  text: string;
  positions: number[]; // zero-based indexes of words to highlight
  className?: string;
}

const HighlightedHeading: React.FC<HighlightedHeadingProps> = ({
  text,
  positions,
  className = "",
}) => {
  if (!text) return null;

  const words = text.split(" ");

  return (
    <h2 className={`text-zinc-800 text-4xl font-medium font-['Barlow_Semi_Condensed'] uppercase leading-[54px] ${className}`}>
      {words.map((word, i) => {
        const isHighlighted = positions.includes(i);
        return (
          <React.Fragment key={i}>
            <span
              className={isHighlighted ? "text-[#F7941D] font-medium" : "text-zinc-800 font-medium"}
            >
              {word}
            </span>
            {i < words.length - 1 && " "}
          </React.Fragment>
        );
      })}
    </h2>
  );
};

export default HighlightedHeading;